enum Permissions {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  MUNICIPALITY = 'municipality'
}

export default Permissions;
